module.exports = "/img/cate-commercial.153a0316.png";